import DeviceAttributeCondition from 'cio/app-models/conditions/device-attribute';
import { serializeFilter as serializeFilterFromAttributeCondition } from 'cio/utils/conditions/serialize/attribute';

export type DeviceAttributeConditionSerializationOptions = {
  useInverse?: boolean;
  useComparisonOperator?: boolean;
};

const OPTIONS_DEFAULT: DeviceAttributeConditionSerializationOptions = {
  useInverse: true,
  useComparisonOperator: false,
};

export function serializeFilter(
  condition: DeviceAttributeCondition,
  options?: DeviceAttributeConditionSerializationOptions,
) {
  let dontAddType = false;
  let { useInverse, useComparisonOperator } = { ...OPTIONS_DEFAULT, ...options };
  let serializedFilter = serializeFilterFromAttributeCondition(
    condition,
    useInverse,
    dontAddType,
    useComparisonOperator,
  );
  serializedFilter.type = 'device_attribute';
  return serializedFilter;
}

export default function (obj: DeviceAttributeCondition) {
  let filter = serializeFilter(obj);

  let name = filter.field;

  let and = [
    {
      ...filter,
      field: 'to',
    },
    {
      ...filter,
      field: 'from',
      inverse: !filter.inverse,
    },
  ];

  return {
    event: {
      type: 'device_change',
      name,
      filters: { and },
    },
    times: 1,
    within: 0,
    inverse: false,
  };
}
